<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.purchasePlace"
              placeholder="请输入团购场所"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 数据请求
import { loadGroupPurchaseInfoMaterialsDetailListDataApi, loadGroupPurchaseInfoMaterialsDetailExportDataApi } from '@/api/groupPurchaseInfo'
export default {
  name: 'GroupPurchaseInfoDetail',
  components: {
    CustomTable,
    TableOperation,
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'team_promotion_detail_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['group_purchase_info_materials_detail_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            purchasePlace: '',
            materialsName: ''
          }
        }
      },
      id: null, // 选中的单据ID
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'gpi.province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 'gpi.city_name', width: 80 },
      { prop: 'countyName', label: '区域', filterColumn: 'gpi.county_name', width: 80 },
      { prop: 'purchaseDateStr', label: '团购时间', filterColumn: 'gpi.purchase_date', width: 110, isBetween: true },
      { prop: 'purchasePlace', label: '团购场所', filterColumn: 'gpi.purchase_place', width: 180 },
      { prop: 'address', label: '团购地址', filterColumn: 'gpi.address', width: 160 },
      // { prop: 'purchaserName', label: '团购人姓名', filterColumn: 'gpi.purchaser_name', width: 160},
      // { prop: 'purchaserPhone', label: '团购人电话', filterColumn: 'gpi.purchaser_phone', width: 160},
      { prop: 'materialsName', label: '物料名称', filterColumn: 'bill.materials_name' },
      { prop: 'unitName', label: '单位', filterColumn: 'bill.unit_name', width: 110 },
      { prop: 'price', label: '单价', filterColumn: 'bill.price', width: 80, isBetween: true },
      { prop: 'amount', label: '数量', filterColumn: 'bill.amount', width: 80, isBetween: true },
      { prop: 'total', label: '合计', filterColumn: 'bill.total', width: 80, isBetween: true },
      { prop: 'operatorName', label: '操作人', filterColumn: 'gpi.operator_name', width: 100 },
      { prop: 'operationTimeStr', label: '操作时间', filterColumn: 'gpi.operation_time', width: 160, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadGroupPurchaseInfoMaterialsDetailListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadGroupPurchaseInfoMaterialsDetailExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
